import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/**
 * Add client
 */

function createClientRequest(client) {
  return {
    type: ACTION_TYPES.CREATE_CLIENT,
    payload: client,
  };
}

function createClientSuccess(client) {
  return {
    type: ACTION_TYPES.CREATE_CLIENT_SUCCESS,
    payload: client,
  };
}

function createClientFailure(error) {
  return {
    type: ACTION_TYPES.CREATE_CLIENT_FAILURE,
    error,
  };
}

export function createClient(clientDetails = {}) {
  return (dispatch, getState) => {
    const { authToken, broker } = getState();
    const payload = {
      authToken,
      broker: broker,
      ...clientDetails,
    };

    dispatch(createClientRequest(clientDetails));
    return new Promise((resolve, reject) => {
      api
        .createClient(payload)
        .then((client) => {
          dispatch(createClientSuccess(client));
          resolve(client);
        })
        .catch((error) => {
          dispatch(createClientFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Update client
 */

function updateClientRequest(clientDetails) {
  return {
    type: ACTION_TYPES.UPDATE_CLIENT,
    payload: clientDetails,
  };
}

function updateClientSuccess(client) {
  return {
    type: ACTION_TYPES.UPDATE_CLIENT_SUCCESS,
    payload: client,
  };
}

function updateClientFailure(error) {
  return {
    type: ACTION_TYPES.UPDATE_CLIENT_FAILURE,
    error,
  };
}

export function updateClient(clientDetails = {}) {
  return (dispatch, getState) => {
    const { authToken, authType, broker } = getState();
    const payload = {
      authToken,
      authType,
      broker: broker,
      ...clientDetails,
    };

    dispatch(updateClientRequest(clientDetails));
    return new Promise((resolve, reject) => {
      api
        .updateClient(payload)
        .then((client) => {
          dispatch(updateClientSuccess(client));
          resolve(client);
        })
        .catch((error) => {
          dispatch(updateClientFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get clients
 */

function getClientsRequest(query) {
  return {
    type: ACTION_TYPES.GET_CLIENTS,
    payload: query,
  };
}

function getClientsSuccess(clients) {
  return {
    type: ACTION_TYPES.GET_CLIENTS_SUCCESS,
    payload: clients,
  };
}

function getClientsFailure(error) {
  return {
    type: ACTION_TYPES.GET_CLIENTS_FAILURE,
    error,
  };
}

export function getClients(filters = {}) {
  return (dispatch, getState) => {
    const { authToken, clients } = getState();
    const query = {
      _offset: clients.length,
      _limit: 25,
      ...filters,
    };

    dispatch(getClientsRequest(query));
    return new Promise((resolve, reject) => {
      api
        .getClients({
          authToken,
          query,
        })
        .then((clients) => {
          dispatch(getClientsSuccess(clients));
          resolve(clients);
        })
        .catch((error) => {
          dispatch(getClientsFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get single client
 */

function getClientRequest(clientId) {
  return {
    type: ACTION_TYPES.GET_CLIENT,
    payload: {
      id: clientId,
    },
  };
}

function getClientSuccess(client) {
  return {
    type: ACTION_TYPES.GET_CLIENT_SUCCESS,
    payload: client,
  };
}

function getClientFailure(error) {
  return {
    type: ACTION_TYPES.GET_CLIENT_FAILURE,
    error,
  };
}

export function getClient(clientId) {
  return (dispatch, getState) => {
    const { authToken, authType } = getState();

    dispatch(getClientRequest(clientId));
    return new Promise((resolve, reject) => {
      api
        .getClient({
          authToken,
          authType,
          clientId,
        })
        .then((client) => {
          dispatch(getClientSuccess(client));
          resolve(client);
        })
        .catch((error) => {
          dispatch(getClientFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get clients stats
 */

function getClientsStatsRequest() {
  return {
    type: ACTION_TYPES.GET_CLIENTS_STATS,
  };
}

function getClientsStatsSuccess(stats) {
  return {
    type: ACTION_TYPES.GET_CLIENTS_STATS_SUCCESS,
    payload: stats,
  };
}

function getClientsStatsFailure(error) {
  return {
    type: ACTION_TYPES.GET_CLIENTS_STATS_FAILURE,
    error,
  };
}

export function getClientsStats(filter = {}) {
  return (dispatch, getState) => {
    const { authToken } = getState();

    dispatch(getClientsStatsRequest());
    return new Promise((resolve, reject) => {
      api
        .getClientsStats({
          authToken,
          filter,
        })
        .then((stats) => {
          dispatch(getClientsStatsSuccess(stats));
          resolve(stats);
        })
        .catch((error) => {
          dispatch(getClientsStatsFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Clear clients
 */

export function clearClientsList() {
  return {
    type: ACTION_TYPES.CLEAR_CLIENTS_LIST,
  };
}
